module.exports = __webpack_public_path__ + "media/images/zoom-mius-bd57be86b70510839c6e1d115304b4b7.svg";